<template>
  <div>
    <div class="section-title">会员服务信息</div>
    <div class="flow-summary-row">
      <div class="flow-card">
        <div class="flow-card-value">{{ flowSummary.monthsOnUse || '' }}</div>
        <div class="flow-card-label">累计使用时长</div>
      </div>
      <div class="flow-card">
        <div class="flow-card-value">{{ flowSummary.totalPaid != null && flowSummary.totalPaid !== '' ?
          flowSummary.totalPaid : '--' }}</div>
        <div class="flow-card-label">累计支付（元）</div>
      </div>
      <div class="flow-card">
        <div class="flow-card-value">{{ flowSummary.currentStatus != null && flowSummary.currentStatus !== '' ?
          flowSummary.currentStatus : '--' }}</div>
        <div class="flow-card-label">当前服务状态</div>
      </div>
      <div class="flow-card flow-card-wide">
        <div class="flow-period">
          <div class="flow-period-time">{{ flowSummary.periodStart || '--' }}</div>
          <div class="flow-period-arrow">→</div>
          <div class="flow-period-time">{{ flowSummary.periodEnd || '--' }}</div>
        </div>
        <div class="flow-card-label">当前服务周期</div>
      </div>
      <div class="flow-card">
        <div class="flow-card-value">{{ flowSummary.remainDays != null && flowSummary.remainDays !== '' ?
          flowSummary.remainDays : '--' }}</div>
        <div class="flow-card-label">会员服务剩余天数</div>
      </div>
    </div>
    <el-table :data="flowBills" size="small" border style="width: 100%">
      <el-table-column type="index" label="" width="55" />
      <el-table-column prop="transactionId" label="支付流水号" min-width="200" />
      <!-- add -->
      <el-table-column prop="deviceCode" label="充电桩设备编号" min-width="200" />
      <el-table-column prop="pileAssetCode" label="充电桩设备资产编号" min-width="200" />
      <el-table-column prop="mobile" label="用户手机号" min-width="200" />
      <el-table-column prop="payTypeName" label="账单类型" min-width="200" />
      <!-- end -->
      <el-table-column prop="payAmount" label="服务费用价格（元）" min-width="140" />
      <el-table-column prop="activeStartDatetime" label="服务开始时间" min-width="180" />
      <el-table-column prop="expiryDatetime" label="服务到期时间" min-width="180" />
      <el-table-column prop="recordStatus" label="服务周期状态" min-width="140">
        <template slot-scope="scope">{{ getServiceStatusText(scope.row.recordStatus) }}</template>
      </el-table-column>
      <el-table-column prop="payType" label="支付方式" min-width="120">
        <template slot-scope="scope">{{ getPayTypeText(scope.row.payType) }}</template>
      </el-table-column>
      <el-table-column prop="payDatetime" label="支付完成时间" min-width="180" />
      <!-- add -->
      <el-table-column prop="walletListStatusName" label="支付结果" min-width="180" />
      <el-table-column prop="createdWhen" label="账单创建时间" min-width="180" />
    </el-table>
  </div>
</template>

<script>
export default {
  name: "FlowServiceInfo",
  props: { flowSummary: { type: Object, required: true }, flowBills: { type: Array, required: true } },
  methods: {
    getServiceStatusText(status) {
      const map = { TO_EXPRIRED: "即将到期", EXPIRED: "已过期", TO_ACTIVE: "待激活", ACTIVE: "正常", IN_ACTIVE: "正常", EXPIRING_SOON: "即将到期", CANCELLED: "已解约（买断）", IN_EXPIRED: "已解约(到期)" };
      return map[status] || status || "--";
    },
    getPayTypeText(payType) {
      const map = { ALIPAY: "支付宝", MANTUAL_ALIPAY: "支付宝", SYSTEM_GIFT: "系统赠送", CYCLE_WITH_HOLD: "自动扣款" };
      return map[payType] || payType || "--";
    },
  },
};
</script>

<style lang="less" scoped>
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.flow-summary-row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.flow-card {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 12px 16px;
  flex: 1;
  min-width: 200px;
  text-align: center;
}

.flow-card-wide {
  flex: 2;
  min-width: 320px;
}

.flow-card-value {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 24px;
}

.flow-card-label {
  margin-top: 6px;
  font-size: 14px;
  color: #666;
}

.flow-period {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.flow-period-time {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}
</style>
